import {
    type DeleteDriveFolderResponseType,
    type DeleteDriveFolderRequestType
} from "./type";
import {
    request
} from "../request";

const DeleteDriveFolder = async (params: DeleteDriveFolderRequestType): Promise<DeleteDriveFolderResponseType> => {
    return await request<DeleteDriveFolderResponseType>("/drive/deleteDriveFolder", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default DeleteDriveFolder;
